//imports
import { HashRouter,Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Landing from './pages/Landing';
import PasswordEdit from './pages/profile/PasswordEdit';
import Settings from './pages/settings/Settings';
import Users from './pages/users/Users';
import UserCreate from './pages/users/UserCreate';
import UserEdit from './pages/users/UserEdit';
import Roles from './pages/roles/Roles';
import RoleCreate from './pages/roles/RoleCreate';
import RoleEdit from './pages/roles/RoleEdit';
import Permissions from './pages/permissions/Permissions';
import PermissionCreate from './pages/permissions/PermissionCreate';
import PermissionEdit from './pages/permissions/PermissionEdit';

//custom New

import B2ctopup from './pages/b2ctopup/B2ctopup';
import B2ctopupCreate from './pages/b2ctopup/B2ctopupCreate';
import B2ctopupEdit from './pages/b2ctopup/B2ctopupEdit';
import Rewardwallet from './pages/rewardwallet/Rewardwallet';
import Subscribe from './pages/Subscribe';
import OtpConfirm from './pages/OtpConfirm'; 
import ErrorBoundary from './components/ErrorBoundary';
import Transactions from './pages/transactions/Transactions';
import Client from './pages/clients/Client';
import ClientCreate from './pages/clients/ClientCreate';
import ClientEdit from './pages/clients/ClientEdit';
import ServiceType from './pages/serviceType/ServiceType';
import ServiceTypeCreate from './pages/serviceType/ServiceTypeCreate';
import ServiceTypeEdit from './pages/serviceType/ServiceTypeEdit';
import SdpService from './pages/sdpService/SdpService';
import SdpServiceCreate from './pages/sdpService/SdpServiceCreate';
import SdpServiceEdit from './pages/sdpService/SdpServiceEdit';
import AppUsers from './pages/appUsers/AppUsers';
import AppUserCreate from './pages/appUsers/AppUserCreate';
import AppUserEdit from './pages/appUsers/AppUserEdit';
import Deposit from './pages/deposit/Deposit';
import DepositCreate from './pages/deposit/DepositCreate';
import DepositEdit from './pages/deposit/DepositEdit';
import InteractiveSms from './pages/interactiveSms/InteractiveSms';
import SmsMessage from './pages/smsMessage/SmsMessage';
import DailyUsers from './pages/dailyUsers/DailyUsers';
import SmsMessageCreate from './pages/smsMessage/SmsMessageCreate';

import Bulkbroadcast from './pages/bulkbroadcast/Bulkbroadcast';
import BulkbroadcastCreate from './pages/bulkbroadcast/BulkbroadcastCreate';
import BulkbroadcastEdit from './pages/bulkbroadcast/BulkbroadcastEdit';
import Senderid from './pages/senderid/Senderid';
import SenderidCreate from './pages/senderid/SenderidCreate';
import SenderidEdit from './pages/senderid/SenderidEdit';  
import PayoutSetting from './pages/payoutSetting/PayoutSetting';
import PayoutSettingCreate from './pages/payoutSetting/PayoutSettingCreate';
import PayoutSettingEdit from './pages/payoutSetting/PayoutSettingEdit';
import Phonebook from './pages/phonebook/Phonebook';
import PhonebookCreate from './pages/phonebook/PhonebookCreate';
import PhonebookEdit from './pages/phonebook/PhonebookEdit';
import Phonebookupload from './pages/phonebookupload/Phonebookupload';
import PhonebookuploadCreate from './pages/phonebookupload/PhonebookuploadCreate';
import PhonebookuploadEdit from './pages/phonebookupload/PhonebookuploadEdit';
import UserWallet from './pages/userWallet/UserWallet';
import UserWalletCreate from './pages/userWallet/UserWalletCreate';
import UserWalletEdit from './pages/userWallet/UserWalletEdit';
import UserWalletStatement from './pages/userWalletStatement/UserWalletStatement';
import UserWalletStatementCreate from './pages/userWalletStatement/UserWalletStatementCreate';
import UserWalletStatementEdit from './pages/userWalletStatement/UserWalletStatementEdit'; 
import ClientBalances from './pages/clients/ClientBalances';
import ControlPanel from './pages/clients/controlPanel';
import GameLoader from './pages/gameLoader/gameLoader';

import Gamelist from './pages/gamelist/Gamelist';
import GamelistCreate from './pages/gamelist/GamelistCreate';
import GamelistEdit from './pages/gamelist/GamelistEdit';
import NoSafcomData from './pages/noSafomData/NoSafcomData';

function App(){
     return (
         <ErrorBoundary>
             <HashRouter>
                 <Routes>
                    <Route path="/login" element={<Login />}/>
                   
                    <Route path="/dashboard" element={<Dashboard />}/>
                    <Route path="/settings" element={<Settings />}/>
                    <Route path="/users" element={<Users />}/>
                    <Route path="/userCreate" element={<UserCreate />}/>
                    <Route path={`/user/:id/edit`} element={<UserEdit />}/>
                    <Route path="/changePassword" element={<PasswordEdit />}/>
                    <Route path="/roles" element={<Roles />}/>
                    <Route path="/roleCreate" element={<RoleCreate />}/>
                    <Route path={`/role/:id/edit`} element={<RoleEdit />}/>
                    <Route path="/permissions" element={<Permissions />}/>
                    <Route path="/permissionCreate" element={<PermissionCreate />}/>
                    <Route path={`/permission/:id/edit`} element={<PermissionEdit />}/>
                    <Route path="/otpConfirm" element={<OtpConfirm />}/>
                    <Route path="/subscribe" element={<Subscribe />}/>
                    <Route path="/" element={<Landing />}/> 
                    <Route path="/transactions" element={<Transactions />}/>
                    <Route path="/client" element={<Client />}/>
                    <Route path="/clientCreate" element={<ClientCreate />}/>
                    <Route path={`/client/:id/edit`} element={<ClientEdit />}/>
                    <Route path="/serviceType" element={<ServiceType />}/>
                    <Route path="/serviceTypeCreate" element={<ServiceTypeCreate />}/>
                    <Route path={`/serviceType/:id/edit`} element={<ServiceTypeEdit />}/>
                    <Route path="/sdpService" element={<SdpService />}/>
                    <Route path="/sdpServiceCreate" element={<SdpServiceCreate />}/>
                    <Route path={`/sdpService/:id/edit`} element={<SdpServiceEdit />}/>
                    <Route path="/appUsers" element={<AppUsers />}/>
                    <Route path="/dailyUsers" element={<DailyUsers />}/>
                    <Route path="/appUserCreate" element={<AppUserCreate />}/>
                    <Route path={`/appUser/:id/edit`} element={<AppUserEdit />}/>
                    <Route path="/deposit" element={<Deposit />}/>
                    <Route path="/depositCreate" element={<DepositCreate />}/>
                    <Route path={`/deposit/:id/edit`} element={<DepositEdit />}/>
                    <Route path="/interactiveSms" element={<InteractiveSms />}/>
                    <Route path="/smsMessage" element={<SmsMessage />}/>
                    <Route path="/smsMessageCreate" element={<SmsMessageCreate />}/>
                    <Route path="/phonebook" element={<Phonebook />}/>
                    <Route path="/phonebookCreate" element={<PhonebookCreate />}/>
                    <Route path={`/phonebook/:id/edit`} element={<PhonebookEdit />}/>
                    <Route path="/phonebookupload" element={<Phonebookupload />}/>
                    <Route path="/phonebookuploadCreate" element={<PhonebookuploadCreate />}/>
                    <Route path={`/phonebookupload/:id/edit`} element={<PhonebookuploadEdit />}/>
                    <Route path="/bulkbroadcast" element={<Bulkbroadcast />}/>
                    <Route path="/bulkbroadcastCreate" element={<BulkbroadcastCreate />}/>
                    <Route path={`/bulkbroadcast/:id/edit`} element={<BulkbroadcastEdit />}/>
                    <Route path="/senderid" element={<Senderid />}/>
                    <Route path="/senderidCreate" element={<SenderidCreate />}/>
                    <Route path={`/senderid/:id/edit`} element={<SenderidEdit />}/>
                    <Route path="/payoutSetting" element={<PayoutSetting />}/>
                    <Route path="/payoutSettingCreate" element={<PayoutSettingCreate />}/>
                    <Route path={`/payoutSetting/:id/edit`} element={<PayoutSettingEdit />}/>
                    <Route path="/b2ctopup" element={<B2ctopup />}/>
                    <Route path="/b2ctopupCreate" element={<B2ctopupCreate />}/>
                    <Route path={`/b2ctopup/:id/edit`} element={<B2ctopupEdit />}/>
                    <Route path="/rewardwallet" element={<Rewardwallet />}/>
                    <Route path="/userWallet" element={<UserWallet />}/>
                    <Route path="/userWalletCreate" element={<UserWalletCreate />}/>
                    <Route path={`/userWallet/:id/edit`} element={<UserWalletEdit />}/>
                    <Route path="/userWalletStatement" element={<UserWalletStatement />}/>
                    <Route path="/userWalletStatementCreate" element={<UserWalletStatementCreate />}/>
                    <Route path={`/userWalletStatement/:id/edit`} element={<UserWalletStatementEdit />}/>
                    <Route path="/clientBalances" element={<ClientBalances />}/>
                    <Route path="/cPanel" element={<ControlPanel/>}/>
                    <Route path="/gameLoader/:id" element={<GameLoader/>}/>
                    <Route path="/gamelist" element={<Gamelist />}/>
                    <Route path="/gamelistCreate" element={<GamelistCreate />}/>
                    <Route path={`/gamelist/:id/edit`} element={<GamelistEdit />}/>
                    <Route path={`/noSafData`} element={<NoSafcomData />}/>
                </Routes>
             </HashRouter>
        </ErrorBoundary>
    );
}
export default App;